import {TimelineI18n} from '@/locales/base.message.locales';

export const timeline: TimelineI18n = {
  messages: {
    interaction_deleted: 'Interação removida',
    interaction_deleted_error: 'Ops, desculpe ocorreu um erro ao tentar remover sua interação',
    interaction_registered: 'Interação registrada',
    interaction_registered_error: 'Ops, desculpe ocorreu um erro ao tentar registrar sua interação',
    reply_registered: 'Resposta registrada',
    reply_registered_error: 'Ops, desculpe ocorreu um erro ao tentar registrar sua resposta',
    end_date: 'Término',
    init_date: 'Início',
    replies_received: 'Respostas recebidas',
    my_interactions: 'Minha atividade',
    you_are_here: 'Você esta aqui'
  }, labels: {
    interaction: 'Adicionar Interação',
    see_interactions: 'Ver Interações',
    add_reply: 'Adicionar Resposta',
    view_reply: 'Ver respostas',
    edit_reply: 'Editar resposta',
    remove_reply: 'Remover resposta',
    load_replies: 'Carregar Respostas',
    description: 'Descrição',
    title: 'Título',
    already_done: 'Você ja fez',
    you_are_here: 'Você esta aqui'
  }
};
